document.addEventListener('DOMContentLoaded', function () {
    devtricker_process_saveSocialLoginOriginalButtonInnerHTML();
    devtricker_attachSocialLoginClickHandlerOnLoad();
    devtricker_url_removeFacebookCharacterOnLoad();
    devtricker_attachRestoreSocialLoginModalOnBrowserGoBack();
});

function devtricker_attachSocialLoginClickHandlerOnLoad() {

    Object.keys(devtricker_socialLoginTypes).forEach((key) => {
        const loginType = devtricker_socialLoginTypes[key];
        const button = document.getElementById(loginType.buttonLoginId);

        if (button) {
            button.addEventListener('click', () => {
                devtricker_process_socialLogin(loginType);
            });
        }
    });
}

function devtricker_attachRestoreSocialLoginModalOnBrowserGoBack() {
    window.addEventListener('pageshow', function (event) {
        if (event.persisted || window.performance.getEntriesByType("navigation")[0].type === 'back_forward') {
            devtricker_dom_restoreOriginalSocialLoginButtons();
        }
    });
}

const devtricker_socialLoginTypes = {
    FACEBOOK: {
        authMethod: 'facebook',
        buttonLoginId: 'login-facebook',
        clientId: g_devtricker_socialLoginSettings.facebookAppId,
        baseUrl: 'https://www.facebook.com/v10.0/dialog/oauth?',
        redirectUri: `${g_devtricker_Settings.siteUrl}/auth/facebook/`,
        scope: 'email,public_profile'
    },
    GOOGLE: {
        authMethod: 'google',
        buttonLoginId: 'login-google',
        clientId: g_devtricker_socialLoginSettings.googleClientId,
        baseUrl: `https://accounts.google.com/o/oauth2/v2/auth?response_type=code&`,
        redirectUri: `${g_devtricker_Settings.siteUrl}/auth/google/`,
        scope: 'https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile'
    },
    GITHUB: {
        authMethod: 'github',
        buttonLoginId: 'login-github',
        clientId: g_devtricker_socialLoginSettings.githubClientId,
        baseUrl: 'https://github.com/login/oauth/authorize?',
        redirectUri: `${g_devtricker_Settings.siteUrl}/auth/github/`,
        scope: 'user:email'
    }
};